<template name="dialog-add">
	<div class="add-group-dialog">
		<!-- 拒绝申请 -->
		<el-dialog
		  title="设置商品分组"
		  :visible.sync="show"
		  :before-close="close"
		  :close-on-click-modal="false"
		>
			<el-input
			  type="input"
			  v-model.trim="cname"
			  placeholder="请填写6字以内分组名称"
			  maxlength="6"
			>
			</el-input>
			<div slot="footer">
				<el-button @click="close">取消</el-button>
				<el-button type="primary" @click="confirm">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	
	import {
		addClassify,
		updateClassify
	} from '@/api/classify';
	
	export default {
		data() {
			return {
			};
		},
		props: {
			id: {
				type: Number,
				default: 0
			},
			cname: {
				type: String,
				default: ''
			},
			show: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			close() {
				this.conent = ''
				this.$emit('close');
			},
			confirm() {
				let id = this.id
				let cname = this.cname;
				if (cname == '') {
					this.$message.error("请填写分组名称");
					return false;
				}
				if(this.id > 0){
					updateClassify({
						id: id,
						name: cname
					}).then(res => {
						if (res.code == 0) {
							this.$message.success('编辑成功');
							this.$emit('success');
						} else {
							this.$message.error(res.message);
						}
					})
				}else{
					addClassify({
						name: cname
					}).then(res => {
						if (res.code == 0) {
							this.$message.success('添加成功');
							this.$emit('success');
						} else {
							this.$message.error(res.message);
						}
					})
				}
			}
		},
		mounted() {}
	}
</script>

<style scoped>
	.add-group-dialog .el-dialog {
		width: 424px;
	}
	.add-group-dialog .gp-textarea textarea {
		height: 100px;
	}
	.add-group-dialog .el-dialog__footer {
		padding-top: 20px;
	}
</style>
